import { createContext, ReactNode, useState } from 'react'

interface INavContext {
  sidenavOpen: boolean
  toggleSidenav: () => void
  moreMenuOpen: boolean
  setMoreMenuOpen: (open: boolean) => void
}

export const NavContext = createContext<INavContext>({
  sidenavOpen: true,
  toggleSidenav: () => {},
  moreMenuOpen: false,
  setMoreMenuOpen: () => {},
})

const SidenavProvider = ({ children }: { children: ReactNode }) => {
  const [sidenavOpen, setSidenavOpen] = useState(true)
  const [moreMenuOpen, setMoreMenuOpen] = useState(false)

  const toggleSidenav = () => setSidenavOpen((prev) => !prev)

  return <NavContext.Provider value={{ sidenavOpen, toggleSidenav, moreMenuOpen, setMoreMenuOpen }}>{children}</NavContext.Provider>
}

export default SidenavProvider
